var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.67022C19 2.80754 17.1441 1.51825 15.4043 2.17227L11.5333 3.62744C10.4946 4.01791 9.80645 5.01332 9.80645 6.12538V15.4515C9.19992 14.9948 8.446 14.7242 7.62903 14.7242C5.62477 14.7242 4 16.3529 4 18.3621C4 20.3712 5.62477 22 7.62903 22C9.63329 22 11.2581 20.3712 11.2581 18.3621V11.1057L17.2732 8.84451C18.3119 8.45404 19 7.45863 19 6.34657V4.67022Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/music-note.589d6afb1b9576fac9edfd82de2e21ac.svg";
export { ForwardRef as ReactComponent };